export enum NotificationCode {
    LINEUP_NOT_DONE = "LINEUP_NOT_DONE",
    QUESTIONS_NOT_ANSWERED = "QUESTIONS_NOT_ANSWERED",
}
